function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { withModifiers } from '../../decorators';
import Icon from '../icon';
import ChatMessage from './message';
import ChatLoader from './loader';
import Text from '../text';

var Chat = function Chat(_ref) {
  var children = _ref.children,
      className = _ref.className,
      placeholder = _ref.placeholder,
      placeholderLabel = _ref.placeholderLabel,
      tabIndex = _ref.tabIndex,
      others = _objectWithoutProperties(_ref, ["children", "className", "placeholder", "placeholderLabel", "tabIndex"]);

  return React.createElement("div", _extends({
    className: "chat-window"
  }, others), React.createElement("div", {
    className: "chat-content"
  }, React.createElement("div", {
    className: "chat-messages",
    role: "status",
    "aria-live": "polite",
    "aria-relevant": "additions"
  }, children && typeof children.valueOf() === 'string' ? React.createElement(Chat.Text, {
    content: children
  }) : children)), React.createElement("div", {
    className: "chat-window-input field"
  }, React.createElement("div", {
    className: "control has-dynamic-placeholder has-icons-right"
  }, React.createElement("input", _extends({
    type: "text",
    className: "input",
    tabIndex: tabIndex
  }, {
    placeholder: placeholder
  })), React.createElement("label", {
    htmlFor: "",
    className: "input-dynamic-placeholder"
  }, React.createElement(Chat.Text, {
    asTag: "span"
  }, placeholderLabel)), React.createElement(Icon, {
    name: "ui-right_arrow",
    "is-right": true
  }))));
};

Chat.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  tabIndex: PropTypes.number,
  placeholderLabel: PropTypes.string
};
Chat.defaultProps = {
  placeholder: 'Message',
  placeholderLabel: 'Votre message',
  tabIndex: 0
};
Chat.Text = Text;
Chat.Message = ChatMessage;
Chat.Loader = ChatLoader;
export default withModifiers(Chat);